<app-header *ngIf="platformService.isWebPlattform"></app-header>
<app-mobile-header *ngIf="!platformService.isWebPlattform"></app-mobile-header>
<main class="main" id="main">
  <div class="router-outlet">
    <router-outlet></router-outlet>
  </div>
  <app-footer *ngIf="platformService.isWebPlattform"></app-footer>
</main>
